<template>
  <div
    slot
    class="inner-wrapper"
  >
    <input
      id="checker"
      type="checkbox"
      @change="toggle"
    >
    <label
      for="checker"
      class="switch"
    />
  </div>
</template>

<script>
import EventBus from '@/EventBus'

export default {
  components: {},
  mixins: [],
  props: {
    initialValue: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      toggleState: false,
    }
  },
  mounted() {
    EventBus.$on('triggerToggle', this.switchState)

    if (this.initialValue) {
      const cb = document.getElementById('checker')
      if (!cb) return

      this.toggleState = this.initialValue
      cb.checked = this.toggleState
    }
  },
  created() {},
  beforeDestroy() {
    EventBus.$off('triggerToggle', this.switchState)
  },  
  methods: {
    toggle() {
      this.$emit('toggle')
      this.toggleState = !this.toggleState
    },
    switchState() {
      const cb = document.getElementById('checker')
      this.toggleState = !this.toggleState
      cb.checked = this.toggleState
      this.$emit('toggle')
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  cursor: pointer;
}

label.switch {
  order: 2;
  display: inline-block;
  position: relative;
  height: 30px;
  width: 60px;
  background: $blue;
  cursor: pointer;
  font-size: 0;
  color: transparent;
  border-radius: 22px;
  transition: background-color 200ms ease;
  box-shadow: 0 4px 6px 0 rgba(23, 21, 63, 0.1);
  &:after {
    transition: right 200ms ease, background-color 200ms ease;
    content: '';
    display: block;
    height: 26px;
    width: 26px;
    position: absolute;
    top: 2px;
    right: 32px;
    border-radius: 50%;
    background-color: #fff;
  }
}
input {
  order: 3;
  position: absolute;
  width: 1 * 3px;
  height: 1 * 3px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  bottom: 0;
  margin-bottom: 9 * 3px;
}
input:checked + label.switch {
  background-color: $blue;
}
input:checked + label.switch:after {
  right: 2px;
  box-shadow: -2px 0px 0px rgba(0, 0, 0, 0.1);
}
label.text-value {
  order: 1;
  flex-grow: 10; // fill remaining space to enable user to click anywhere
  color: #b2b6e1;
  font-family: $medium;
  font-size: 14px;
  margin-bottom: 9px;
  cursor: pointer;
}
input:checked ~ label.text-value {
  color: $black;
}
</style>
